module.exports = __webpack_public_path__ + "img/chart_more.edc95288.svg";